import { useUserStore } from '~/store/useUserStore'

export const useDashboardAware = () => {
  const store = useUserStore()
  const config = useRuntimeConfig()

  const { isLoggedIn, fullName } = storeToRefs(store)
  const configDashboardUrl = config.public.dashboardUrl

  const dashboardUrl = computed<Maybe<string>>(() => {
    if (!import.meta.client) {
      return null
    }
    return configDashboardUrl
  })

  return {
    dashboardUrl,
    fullName,
    isLoggedIn,
  }
}
